import { Box, Button, IconButton, List, ListItem, Modal } from "@mui/material";
import { Typography } from "@mui/material";
import { TEXT_COLOR } from "../../theme";
import { shareModalStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";

export const SubscriptionInfoModal: React.FC<{
  open: boolean;
  handleCloseModal: () => void;
}> = ({ open, handleCloseModal }) => {
  const handleClose = () => {
    handleCloseModal();
  };

  return (
    <Modal open={open ? open : false} onClose={handleClose}>
      <Box sx={shareModalStyles.subscriptionInfoModal}>
        <Box
          sx={{
            ...shareModalStyles.mainContainer,
            maxWidth: "500px",
            width: "100%",
            borderRadius: "8px",
            boxShadow: 24,
            padding: "16px",
          }}
        >
          <Box sx={shareModalStyles.topBarIconContainer}>
            <Box sx={{ mt: 1 }}>
              <Typography sx={shareModalStyles.title}>
                Welcome to OmMuse
              </Typography>
            </Box>
            <Box sx={shareModalStyles.closeIconContainer}>
              <IconButton onClick={handleClose}>
                <CloseIcon sx={{ fontSize: "30px" }} />
              </IconButton>
            </Box>
          </Box>

          <Typography sx={{ color: TEXT_COLOR, mt: 2, fontWeight: "bold" }}>
            Welcome to your 7-day free trial of OmMuse Major!
          </Typography>
          <Typography sx={{ color: TEXT_COLOR, mt: 1 }}>
            Now you can:
          </Typography>

          <List sx={shareModalStyles.listContainer}>
            <ListItem sx={shareModalStyles.listItem}>
              Upload & store up to 1TB of music files & stems
            </ListItem>
            <ListItem sx={shareModalStyles.listItem}>
              Access our exclusive network of collaborations
            </ListItem>
            <ListItem sx={shareModalStyles.listItem}>
              Project manage your tracks with version control
            </ListItem>
            <ListItem sx={shareModalStyles.listItem}>
              Add music to our Explore page for discoverability
            </ListItem>
            <ListItem sx={shareModalStyles.listItem}>
              Professionally master music with Dolby AI Mastering
            </ListItem>
            <ListItem sx={shareModalStyles.listItem}>
              & so much more...
            </ListItem>
          </List>

          {/* Tutorial Link */}
          <Typography sx={{ color: TEXT_COLOR }}>
            Get started by selecting <strong>&quot;Add Music&quot;</strong> on
            the top right or watch our tutorial to learn more:
            <a
              href="https://youtu.be/XGk8vJjUdTg?si=otpEO5mDnN157hQ"
              target="_blank"
              rel="noopener noreferrer"
              style={shareModalStyles.watchTutorial}
            >
              Watch Tutorial
            </a>
          </Typography>

          <Box sx={shareModalStyles.closeButtonContainer}>
            <Button
              sx={shareModalStyles.updatePlanButton}
              onClick={handleClose}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
